// extracted by mini-css-extract-plugin
module.exports = {"container":"part-services-list_container__EY3VA","servicesList":"part-services-list_servicesList__m6dc_"};